import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-xs font-semibold uppercase tracking-wide text-primary-600">
          {t("catSection.eyebrow")}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          {t("catSection.title")}
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
          {t("catSection.subtitle")}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
          >
            <div className="aspect-[4/3] w-full overflow-hidden">
              <img
                src={cat.image}
                alt={`${t(`cat.${cat.id}`)} — Basetao Spreadsheet`}
                title={`${t(`cat.${cat.id}`)} Basetao Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 px-3 py-3 md:px-4">
              <span className="truncate text-sm font-semibold text-foreground-900 md:text-base">
                {t(`cat.${cat.id}`)}
              </span>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-white">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}